import { Suspense, lazy } from "react";

const LazyReactMarkdown = lazy(() =>
  import("./markdown-text").then((module) => ({
    default: module.MarkdownText,
  })),
);

export interface MarkdownText {
  className?: string;
  text: string;
}

export function MarkdownText(props: MarkdownText) {
  return (
    <Suspense>
      <LazyReactMarkdown {...props} />
    </Suspense>
  );
}
